import { render, staticRenderFns } from "./Duration.vue?vue&type=template&id=b7bbf988&scoped=true&"
import script from "./Duration.vue?vue&type=script&lang=js&"
export * from "./Duration.vue?vue&type=script&lang=js&"
import style0 from "./Duration.vue?vue&type=style&index=0&id=b7bbf988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bbf988",
  null
  
)

export default component.exports